import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { YolocoasterAnnouncementCSS } from './YolocoasterAnnouncementCSS.styled'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const YolocoasterAnnouncement = () => {
  const navigateTo = useNavigate()
  const { activeAsset, setActiveAsset } = useLvgState()
  const [buttonClicked, setButtonClicked] = useState(false)
  const onSelectYoloCoaster = (e) => {
    e.preventDefault()
    navigateTo(`/game/${CONTENT_TYPES.LVG_CRYPTO}`)
    setButtonClicked(true)
  }
  
  useEffect(() => {
    if (activeAsset.id !== 'YOLOCOASTER' && buttonClicked) {
      const yolocoasterInfo = LVG_ASSETS.filter((asset) => asset.id === 'YOLOCOASTER').at(0)
      setActiveAsset(yolocoasterInfo, CONTENT_TYPES.LVG_CRYPTO)
      setButtonClicked(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonClicked, activeAsset?.id])

  return (
    <YolocoasterAnnouncementCSS>
      <div className='yolocoaster_announcement'>
        <div className='title'>
          <div className='new_icon'></div>
          Ride the YOLOCOASTER
        </div>
        <div className='subtitle'>
          Announcing the new "gamified crypto".
          <br /> Bid on randomly generated prices with
          <br /> consistent volatility - lots of fun for high leverage.
          <br />
        </div>
        <form>
          <button className='yc_select' onClick={onSelectYoloCoaster}>
            Get started
          </button>
        </form>
        <div className='yc_icon'></div>
      </div>
    </YolocoasterAnnouncementCSS>
  )
}
